import { AppButton } from "components/form";
import { AppSpacer } from "components/ui";
import { useStores } from "index";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ITrackingDiagnostic } from "types/models/TrackingDiagnosticsModel";

interface ITrackingDiagnosticsTableControlProps {
    visibleRows?: ITrackingDiagnostic[];
    allSelectedTrackingDiagnosticIds: string[] | null;
    onCreate: () => void;
    onSelect: () => void;
}

export const TrackingDiagnosticsTableControl = observer(({ visibleRows, allSelectedTrackingDiagnosticIds, onCreate, onSelect }: ITrackingDiagnosticsTableControlProps) => {
    const { t } = useTranslation();

    const { trackingDiagnosticsStore, diagnosticsPackagesStore } = useStores();

    return (
        <div className='w-100'>
            <div className='d-flex justify-content-end align-items-center w-100'>
                <AppButton
                    variant='secondary'
                    className='border-secondary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        if (visibleRows) {
                            trackingDiagnosticsStore.addRangeSelectedTrackingDiagnosticList(visibleRows);
                        }
                    }}
                    disabled={!visibleRows || visibleRows.length === 0}
                >
                    {t('TrackingDiagnostics.Action.SelectAll')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='warning'
                    className='border-warning'
                    onClick={(e) => {
                        e?.stopPropagation();
                        trackingDiagnosticsStore.clearSelectedTrackingDiagnosticList();
                    }}
                    disabled={!allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0}
                >
                    {t('TrackingDiagnostics.Action.Clear')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='primary'
                    className='border-primary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        onSelect();
                    }}
                    disabled={!allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0 || diagnosticsPackagesStore.diagnosticsPackages.length === 0}
                >
                    {t('TrackingDiagnostics.Action.SelectPackage')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='primary'
                    className='border-primary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        onCreate();
                    }}
                    disabled={!allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0}
                >
                    {t('TrackingDiagnostics.Action.CreatePackage')}
                </AppButton>
            </div>
            <AppSpacer space='15px' />

            <div className='d-flex justify-content-end align-items-center w-100'
                style={{ visibility: !allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0 ? 'hidden' : 'visible' }}>
                <p className="font-10 font-700 font-lato text-capitalize color-secondaryGrey mb-0">{t(`${t('DiagnosticsPackages.SelectPackage.Message', { amount: `${allSelectedTrackingDiagnosticIds?.length || 0}` })}`)}</p>
            </div>
        </div>
    )
});

export default TrackingDiagnosticsTableControl;